var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateAutomationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.478 4h-6.956a4.353 4.353 0 00-4.348 4.348v6.956a4.353 4.353 0 004.348 4.348h6.956a4.353 4.353 0 004.348-4.348V8.348A4.353 4.353 0 0027.478 4z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.739 35.304h-4.174a2.263 2.263 0 00-2.26 2.261v4.174a2.263 2.263 0 002.26 2.26h4.174a2.263 2.263 0 002.26-2.26v-4.174a2.263 2.263 0 00-2.26-2.26zM10.435 35.304H6.26A2.263 2.263 0 004 37.565v4.174A2.263 2.263 0 006.26 44h4.175a2.263 2.263 0 002.26-2.26v-4.174a2.263 2.263 0 00-2.26-2.26z",
    fill: "#597EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.434 26.609H24.87V22.26a.87.87 0 00-1.739 0v4.348h-9.565a6.094 6.094 0 00-6.087 6.087.87.87 0 001.74 0 4.353 4.353 0 014.347-4.348h20.87a4.353 4.353 0 014.347 4.348.87.87 0 001.74 0 6.094 6.094 0 00-6.087-6.087z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/create-automation-icon.be5e19a8179c5971ee4dd0a2ae0e8cb6.svg";
export { SvgCreateAutomationIcon as ReactComponent };